/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_R_LangInputs */

const en_mk_cmp_r_lang = /** @type {(inputs: Mk_Cmp_R_LangInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indonesian language`)
};

const id_mk_cmp_r_lang = /** @type {(inputs: Mk_Cmp_R_LangInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Indonesia`)
};

/**
* | output |
* | --- |
* | "Indonesian language" |
*
* @param {Mk_Cmp_R_LangInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_r_lang = /** @type {((inputs?: Mk_Cmp_R_LangInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_R_LangInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_r_lang(inputs)
	return en_mk_cmp_r_lang(inputs)
});